export const SET_API_ERROR = "SET_API_ERROR";
type SET_API_ERROR = typeof SET_API_ERROR;

export const CLEAR_API_ERROR = "CLEAR_API_ERROR";
type CLEAR_API_ERROR = typeof CLEAR_API_ERROR;

export type SetAPIErrorAction = {
  type: SET_API_ERROR;
  payload: string;
};

export type ClearAPIErrorAction = {
  type: CLEAR_API_ERROR;
  payload: string;
};
